import { RiskFactor } from './risk-factor';
import { RiskFactorRank } from './risk-factor-rank';

export class AssessmentFactorSelection {
  type: RiskFactor;
  factor: RiskFactorRank;
}
